<template>
  <div class="product" id="product">
    <v-app>
      <v-app-bar
      app
      color='primary'
      dark
      height="564"
      absolute
      >
        <v-row align="start">
          <!-- 一级导航栏 -->
          <FirstNavbar  :pc='pc' :tab_index="first_active_tab" :barHide="barHide" :barColor="barColor"></FirstNavbar>
          <!-- 大标题 -->
          <div class='first_title_box'  style="width:100%;height:calc(564px - 64px);" >
            <v-row align="center" justify="center">
              <v-col  cols="12">
                <h1 class="first_title white--text">
                  云服务
                </h1>
                <h4 class="body_text white--text">
                  <span>诚信</span><span>规范</span><span>创新</span><span>高效</span>
                </h4>
              </v-col>
            </v-row>
          </div>
          <!-- 首屏大图 -->
          <div style="width:100%;height:500px;position:absolute;z-index:-3;margin-left:-4px">
            <v-parallax height="564" dark src="../assets/images/云产品顶部.png">
            </v-parallax>
          </div>
        </v-row>
      </v-app-bar>
      <v-main>
        <v-app-bar
          :fixed='second_bar_fixed'
          prominent
          height="64"
          color="white"
          :flat='!second_bar_fixed'
        >
          <v-tabs v-model="second_active_tab" centered>
            <v-tab v-for="tab in contentList" :key='tab.index'  @click="goTo(tab.index)" class="body_text">{{tab.firstTitle}}</v-tab>
          </v-tabs>
        </v-app-bar>
        <div class="aboutContent">
          <v-row dense>
            <v-col cols="12">
              <!-- 云产品 -->
              <BoxTitle :firstTitle="contentList[0].firstTitle" :desc="contentList[0].desc" :index="contentList[0].index"></BoxTitle>
              <BoxLr :data='contentList[0].children[0]' :left_img="true" :dark="false"></BoxLr>
              <BoxLr :data='contentList[0].children[1]' :left_img="false" :dark="false"></BoxLr>
              <BoxLr :data='contentList[0].children[2]' :left_img="true" :dark="false"></BoxLr>
              <!-- 云平台 -->
              <BoxTitle :firstTitle="contentList[1].firstTitle" :desc="contentList[1].desc" :index="contentList[1].index" :dark='true'></BoxTitle>
              <BoxLr :data='contentList[1].children[0]' :left_img="false" :dark='true'></BoxLr>
              <BoxLr :data='contentList[1].children[1]' :left_img="true" :dark='true'></BoxLr>
              <BoxLr :data='contentList[1].children[2]' :left_img="false" :dark='true'></BoxLr>
             <!-- 悬浮图标-回到顶部 -->
              <v-fab-transition>
                <v-btn
                  v-show="!floatHidden"
                  color="primary"
                  fixed
                  bottom
                  right
                  fab
                  @click="goTo(0)"
                >
                  <v-icon>mdi-arrow-up</v-icon>
                </v-btn>
              </v-fab-transition>
            </v-col>
          </v-row>
        </div>
      </v-main>
    <v-footer  color="secondary" style="height:auto">
      <FootContent :active="footList.active" :listWidth="footList.listWidth"></FootContent>
    </v-footer>
    </v-app>
  </div>
</template>

<script>
import FootContent from '../components/footer.vue'
import FirstNavbar from '../components/first-navbar.vue'
import BoxLr from '../components/box-lr.vue'
import BoxTitle from '../components/box-title.vue'

export default {
  name: 'products',

  components: {
    FootContent,
    FirstNavbar,
    BoxLr,
    BoxTitle
  },

  data: () => ({
    // 导航背景颜色
    barColor: 'rgba(63, 81, 181,0)',
    // 导航栏是否隐藏
    barHide: true,
    // 是否为PC端
    pc: false,
    // 悬浮按钮是否隐藏
    floatHidden: true,
    // 一级导航选项卡
    first_active_tab: 4,
    // 二级导航选项卡
    second_active_tab: 0,
    // 二级导航是否冻结
    second_bar_fixed: false,
    // 页脚参数
    footList: {
      listWidth: '10rem',
      active: [true, true, true]
    },
    // 内容列表
    contentList: [{
      index: 1,
      firstTitle: '云产品',
      desc: '',
      scrollTop: '',
      children: [{
        index: 1,
        src: '云产品云桌面.jpg',
        content: {
          title: '云桌面',
          body: '云桌面采用云计算技术改造办公桌面，将用户桌面集中在数据中心，通过虚拟化技术组建资源池，打造一种全新的、安全、便捷、高效的工作方式',
          btn: '',
          list: [{
            index: 1,
            src: '',
            title: '通过数据与用户隔离提升安全性',
            subtitle: '',
            body: ''
          }, {
            index: 2,
            src: '',
            title: '通过资源大集中提升运维效率',
            subtitle: '',
            body: ''
          }, {
            index: 3,
            src: '',
            title: '通过网络接入提升办公灵活性',
            subtitle: '',
            body: ''
          }]
        }
      }, {
        index: 2,
        src: '云服务云课堂.jpg',
        content: {
          title: '云课堂',
          body: '云课堂为学校及机构提供一站式在线教育平台，无需开发软件和搭建服务器，一键开通使用，帮助客户打破技术壁垒，解决师资紧缺、空间限制、时间冲突等问题',
          btn: '',
          list: [{
            index: 1,
            src: '',
            title: '提供互动课堂解决方案，多终端覆盖，支持高清视频播放、文件共享，打破技术壁垒',
            subtitle: '',
            body: ''
          }, {
            index: 2,
            src: '',
            title: '覆盖“教、学、考、管“等教学全流程，线上线下效果一样好',
            subtitle: '',
            body: ''
          }, {
            index: 3,
            src: '',
            title: '提供服务器、数据库、带宽等基础资源，降低资金成本',
            subtitle: '',
            body: ''
          }]
        }
      }, {
        index: 3,
        src: '云服务云开发.jpg',
        content: {
          title: '云开发',
          body: '云开发为开发者提供完整的后端云服务，提供数据库、存储、函数、静态托管等基础能力，以及扩展能力；无需管理基础架构，无需购买数据库、存储等基础设施服务，无需搭建服务器即可使用',
          btn: '',
          list: [{
            index: 1,
            src: '',
            title: '无需搭建服务器，降低开发门槛',
            subtitle: '',
            body: ''
          }, {
            index: 2,
            src: '',
            title: '自动扩容，资源利用最大化',
            subtitle: '',
            body: ''
          }]
        }
      }]
    }, {
      index: 2,
      firstTitle: '云平台',
      desc: '',
      scrollTop: '',
      children: [{
        index: 1,
        src: '云产品负载均衡.jpg',
        content: {
          title: '负载均衡',
          btn: '',
          body: '均衡应用程序的流量，将前端并发访问转发给后台多台云服务器，实现业务水平扩展；可通过故障自动切换，及时地消除服务的单点故障，提升服务的可用性',
          list: [{
            index: 1,
            src: '',
            title: '多协议支持:支持TCP协议和UDP协议，满足多样化的应用场景',
            subtitle: '',
            body: ''
          }, {
            index: 2,
            src: '',
            title: '高可用性:定时检测后端服务器运行状况，对于异常服务器，不再转发流量，保证可用性',
            subtitle: '',
            body: ''
          }, {
            index: 3,
            src: '',
            title: '高弹性:无需预测业务峰值，随业务自动调整的自动弹性能力，减轻运维压力',
            subtitle: '',
            body: ''
          }]
        }
      }, {
        index: 2,
        src: '云产品内容分发.jpg',
        content: {
          title: '内容分发',
          body: '将源站内容分发至全国所有的节点，缩短用户查看内容的延迟，提高用户访问网站的响应速度与网站的可用性，解决网络带宽小、用户访问量大、网点分布不均等问题',
          btn: '',
          list: [{
            index: 1,
            src: '',
            title: '就近接入：用户的流量通过访问接入点IP地址，或CNAME地址就近接入',
            subtitle: '',
            body: ''
          }, {
            index: 2,
            src: '',
            title: '后端应用跨地域部署：实现不同地域服务之间的负载分担和高可用容灾',
            subtitle: '',
            body: ''
          }, {
            index: 3,
            src: '',
            title: '高可用性：定时检测后端服务器运行状况，对于异常服务器，不再转发流量，保证可用性',
            subtitle: '',
            body: ''
          }]
        }
      }, {
        index: 3,
        src: '云产品云储存.jpg',
        content: {
          title: '云存储',
          body: '针对海量数据分层存储，安全、低成本、高可靠，可以在互联网任何位置存储和访问，容量和处理能力弹性扩展，多种存储类型供选择，全面优化存储成本',
          btn: '',
          list: [{
            index: 1,
            src: '',
            title: '高可靠性：多重冗余架构设计，为数据持久存储提供可靠保障',
            subtitle: '',
            body: ''
          }, {
            index: 2,
            src: '',
            title: '低成本：无需提前一次性投入，自动弹性扩展，按需按量付费',
            subtitle: '',
            body: ''
          }, {
            index: 3,
            src: '',
            title: '方便易用：图形化工具，快速上手，方便随时随地通过网络管理数据',
            subtitle: '',
            body: ''
          }]
        }
      }]
    }]
  }),
  mounted () {
    this.goTo(0)
    // // 鼠标滚动事件监听
    window.addEventListener('scroll', this.handleScroll)
    this.contentList.forEach((val, index, arry) => {
      this.contentList[index].scrollTop = this.$el.querySelector('#part' + this.contentList[index].index).offsetTop + 564
    })
    var that = this
    that.whatScreen()
    // 屏幕尺寸监听
    window.onresize = function () {
      that.whatScreen()
    }
  },

  methods: {
    // 屏幕
    whatScreen () {
      var width = document.querySelector('html').offsetWidth
      if (width <= 768) {
        // title.innerHTML = "极小屏幕-" + width
        this.footList.active = [false, false, false]
        this.footList.listWidth = '90rem'
        this.pc = false
      } else {
        if (width > 768 && width <= 992) {
          // title.innerHTML = "小屏幕-" + width
          this.footList.active = [true, true, true]
          this.footList.listWidth = '10rem'
          this.pc = false
        } else {
          if (width > 992 && width <= 1100) {
            // title.innerHTML = "普通屏幕-" + width
            this.footList.active = [true, true, true]
            this.footList.listWidth = '10rem'
            this.pc = true
          } else {
            if (width > 1200 && width <= 1600) {
              // title.innerHTML = "大屏幕-" + width
              this.footList.active = [true, true, true]
              this.footList.listWidth = '10rem'
              this.pc = true
            } else {
              if (width > 1600) {
                // title.innerHTML = "大屏幕-" + width
                this.footList.listWidth = '10rem'
                this.footList.active = [true, true, true]
                this.pc = true
              }
            }
          }
        }
      }
    },
    // 一级导航跳转定位
    toguid (path_, id) {
      const path = path_
      const Id = id
      localStorage.setItem('toId', Id)
      this.$router.push(path)
    },
    //  鼠标滚动事件（导航栏是否透明、导航栏是否隐藏投影、导航选项卡切换，悬浮按钮是否出现）
    handleScroll () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 500) {
        this.second_bar_fixed = true
        this.gotop = true
      } else {
        this.second_bar_fixed = false
        this.barColor = 'rgba(63, 81, 181,0)'
        this.gotop = false
      }
      if (scrollTop < this.contentList[0].scrollTop) {
        this.second_active_tab = 0
        this.floatHidden = false
      } else if (scrollTop > this.contentList[this.contentList.length - 1].scrollTop) {
        this.second_active_tab = this.contentList.length - 1
        this.floatHidden = false
      } else {
        for (var i = 1; i < this.contentList.length; i++) {
          if (i <= this.contentList.length) {
            if (scrollTop >= this.contentList[i - 1].scrollTop & scrollTop < this.contentList[i].scrollTop) {
              this.second_active_tab = i - 1
              this.floatHidden = false
            }
          }
        }
      }
    },
    goTo (index) {
      // console.log(this.secondTabs, ele)
      // var anchor = this.$el.querySelector(ele)
      if (index === 0) {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      } else {
        document.body.scrollTop = document.documentElement.querySelector('#part' + this.contentList[index - 1].index).offsetTop + 564
        document.documentElement.scrollTop = document.documentElement.querySelector('#part' + this.contentList[index - 1].index).offsetTop + 564
      }
    }
  }

}
</script>

<style>

</style>
